import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import User from '@/models/User'
import Logger from '@/lib/Logger'

class Workspace {
  static attributeNames() {
    return ['id', 'name']
  }

  static getClean(dirtyObj) {
    let cleanObject = {}
    this.attributeNames().forEach(attrname => {
      if (attrname in dirtyObj) {
        cleanObject[attrname] = dirtyObj[attrname]
      }
    })
    return cleanObject
  }

  static find({ get, by, onChange, onError }) {
    return GqlClient.activeQuery({
      retrieveGql: {
        dataKey: 'workspaceGet',
        query: gql`
          query($workspaceId: ID!) {
              workspaceGet (workspaceId: $workspaceId)
              ${get}
          }`,
        variables: {
          workspaceId: by.id,
        },
      },
      listenGql: {
        dataKey: 'workspaceChanged',
        query: gql`
          subscription {
            workspaceChanged (workspaceId: ${by.id}) {
              id
            }
          }`,
      },
      onDataChange: data => {
        Logger.debug('Workspace CHANGED:', by, data)
        onChange(data)
      },
      onError: error => onError(error),
    })
  }

  static addNew(newWorkspace) {
    Logger.debug('addMaster', newWorkspace)
    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: WorkspaceInput!) {
          workspaceAdd(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: newWorkspace,
      },
    })
  }

  static save(workspace) {
    Logger.debug('Workspace.save', workspace)

    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: WorkspaceInput!) {
          workspaceChange(input: $input) {
            workspace {
              id
              name
            }
          }
        }
      `,
      variables: {
        input: this.getClean(workspace),
      },
    })
  }

  static delete(workspace) {
    return GqlClient.runMutation({
      mutation: gql`
        mutation($workspaceId: ID!) {
          workspaceDelete(workspaceId: $workspaceId) {
            info
          }
        }
      `,
      variables: {
        workspaceId: workspace.id,
      },
    })
  }

  static async userAdd(workspace, user) {
    const result = await GqlClient.runMutation({
      dataKey: 'workspaceUserAdd',
      mutation: gql`
        mutation($workspaceId: ID!, $user: UserInput!) {
          workspaceUserAdd(workspaceId: $workspaceId, user: $user) {
            user {
              id
              email
              firstName
              lastName
              termsAccepted
            }
          }
        }
      `,
      variables: {
        workspaceId: workspace.id,
        user: User.getClean(user),
      },
    })
    // Logger.debug("userAdd => ", result)
    return result.user
  }

  static userRemove(workspace, user) {
    return GqlClient.runMutation({
      mutation: gql`
        mutation($workspaceId: ID!, $user: UserInput!) {
          workspaceUserRemove(workspaceId: $workspaceId, user: $user) {
            wsAccesses {
              user {
                id
              }
            }
          }
        }
      `,
      variables: {
        workspaceId: workspace.id,
        user: User.getClean(user),
      },
    })
  }

  static async userInvite(workspaceId, user) {
    const result = await GqlClient.runMutation({
      dataKey: 'workspaceUserInvite',
      mutation: gql`
        mutation($workspaceId: ID!, $user: UserInput!) {
          workspaceUserInvite(workspaceId: $workspaceId, user: $user) {
            user {
              id
              email
              firstName
              lastName
              termsAccepted
            }
          }
        }
      `,
      variables: {
        workspaceId: workspaceId,
        user: User.getClean(user),
      },
    })
    return result.user
  }
}

export default Workspace
